import React from "react";
import useAuthStore from "../../stores/useAuthStore";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { USER_TYPE_ICONS } from "../../Utilities/userTypeIcons";

function ButtonLogout() {
  const signOut = useAuthStore((state) => state.signOut);

  var role = localStorage.getItem("role") ? localStorage.getItem("role") : "";
  var email = localStorage.getItem("email");

  return (
    <div className="logout--button-container">
      <div className="logout--button" onClick={signOut}>
        <p className="logout--text">
          <FormattedMessage id="LogOut" />
        </p>
      </div>
      <div className="logout--icon-container">
        <FontAwesomeIcon icon={USER_TYPE_ICONS[role] ?? "user"} />
      </div>
      <div className="logout--email-container">
        <span>{email}</span>
      </div>
    </div>
  );
}

export default ButtonLogout;
